import React from 'react';
import shared from './SystemHealthPage.module.scss';

/** "Live", "Stale" (real data, latest update failed) or "Dummy" pill for a card or tile header. */
export const SourceBadge: React.FC<{ live: boolean; stale?: boolean }> = ({ live, stale }) =>
    live && stale ? (
        <span className={shared.dummyBadge} title="The latest update failed; this is from an earlier one">
            Stale
        </span>
    ) : (
        <span className={live ? shared.liveBadge : shared.dummyBadge}>{live ? 'Live' : 'Dummy'}</span>
    );
